<template>
    <!--<div class="roothome">-->
    <div class="roothome_m">

        <div class="wrapper">
            <!-- Sidebar Holder -->
            <nav id="sidebar">
                <div id="dismiss">
                    <!--<img src="/static/imgs/ic_menu.png" alt="menu" class="im_menu1">-->
                </div>

                <div class="sidebar-header" style="font-size: 1.1em; display: flex; align-items: center;">

                    <div style="width: 100%; text-align: center;">
                        <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="width: 70%; margin-top: 5vh; margin-bottom: 2.5vh;">
                    </div>

                    <div style="margin-bottom: 2.5vh">
                        <span class="tx_idioma" v-if="user.idioma==0" style="font-family: 'Humanst521BT';">Português</span>
                        <span class="tx_idioma" v-if="user.idioma!=0" @click="changeIdioma(0)">Português</span>
                        <span class="tx_idioma">&#149;</span>
                        <span class="tx_idioma" v-if="user.idioma==1" style="font-family: 'Humanst521BT';">English</span>
                        <span class="tx_idioma" v-if="user.idioma!=1" @click="changeIdioma(1)">English</span>
                        <span class="tx_idioma">&#149;</span>
                        <span class="tx_idioma" v-if="user.idioma==2" style="font-family: 'Humanst521BT';">Español</span>
                        <span class="tx_idioma" v-if="user.idioma!=2" @click="changeIdioma(2)">Español</span>
                    </div>

                    <div v-if="user.sucess" style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                        <span style="font-size: 2.5vh;">{{ getInterText(inter_ind.ola) }} {{ getFirstAndLastWords(user.nome) }}</span>

                        <div class="div_botao_t" @click="logout()" onMouseOver="this.style.cursor='pointer'">
                            <span class="tx_continuar"> {{ getInterText(inter_ind.sair) }} </span>
                        </div>
                    </div>
                    <div v-else style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                        <router-link to="mRegisterUser" style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                            <div class="div_botao_t_w">
                                <span class="tx_continuar"> {{ getInterText(inter_ind.cadastre) }} </span>
                            </div>
                        </router-link>

                        <div class="div_botao_t" @click="setShowLogin(true)">
                            <span class="tx_continuar"> {{ getInterText(inter_ind.entrar) }} </span>
                        </div>
                    </div>


                    <!--<div class="custom-select-filtro">-->
                        <!--<select id="sel_cats" @change="changeCity($event)" v-model="cityIndex" >-->
                            <!--<option value="0" v-if="city_full.length > 0"> {{ city_full[0].nome }} </option>-->
                            <!--<option v-for="(item, index) in city_full" :value="index" v-if="index > 0"> {{ item.nome }} ({{ item.quant }}) </option>-->
                        <!--</select>-->
                        <!--<img src="/static/imgs/ic_down.png" style="width: 5%; margin-right: 3%; object-fit: contain;">-->
                    <!--</div>-->


                </div>
                <ul class="list-unstyled components" style="margin-top: 0; overflow-y: scroll; font-size: 5vw;">
                    <li class="active">
                        <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.categorias) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu" >
                            <li v-for="(item, index) in cats_full" @click="atualizaEstabs(item.id, true)" v-if="index > 0">
                                <div class="lineMenu">
                                    <img v-if="item.imgPath2!=null" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" class="im_cat_min">
                                    <span>{{ getInterCatName(item) }}</span>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li @click='goToPagina("mVisao")'>
                        <a style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.quem_somos) }}</a>
                    </li>

                    <li class="active">
                        <a style="font-family: 'Humanst521BT';" href="#pageSubmenu3" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu3">{{ getInterText(inter_ind.nossas_redes) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu3" >
                            <li>
                                <a href="https://www.facebook.com/adviceparaiba" target="_blank">
                                    <img src="/static/imgs/ic_facebookmenu.png" class="im_cat_min_2">
                                    <span>Facebook</span>
                                </a>
                                <a href="https://www.youtube.com/channel/UCbWLHHK-IIHT6BZRWU0n5eg" target="_blank">
                                    <img src="/static/imgs/ic_youtubemenu.png" class="im_cat_min_2">
                                    <span>YouTube</span>
                                </a>
                                <a href="https://www.instagram.com/adviceparaiba/" target="_blank">
                                    <img src="/static/imgs/ic_instagrammenu.png" class="im_cat_min_2">
                                    <span>Instagram</span>
                                </a>
                                <a href="https://twitter.com/AdviceParaiba" target="_blank">
                                    <img src="/static/imgs/ic_twittermenu.png" class="im_cat_min_2">
                                    <span>Twitter</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li @click='goToPagina("tabua")'>
                        <a style="font-family: 'Humanst521BT'; pointer-events: none;"> {{ getInterText(inter_ind.tabua_mares) }} </a>
                    </li>
                    <!--<li @click="changeShow10Mais()">-->
                        <!--<a style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.os) }} 10+</a>-->
                    <!--</li>-->
                    <li @click='goToPagina("mContato")'>
                        <a style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.contato) }}</a>
                    </li>
                    <li @click='goToPagina("mExpedicaoAdvice")'>
                        <a style="font-family: 'Humanst521BT'; pointer-events: none;">{{ getInterText(inter_ind.expedicao) }}</a>
                    </li>
                    <li class="active">
                        <a style="font-family: 'Humanst521BT';" href="#pageSubmenu2" data-toggle="collapse"x aria-expanded="false" aria-controls="pageSubmenu2">{{ getInterText(inter_ind.telefones_uteis) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu2">
                            <li v-for="item in telefoneUteis">
                                <a :href="'tel:' + trimAll(item.tel)" style="margin-left: 5px">{{ getInterText(item.nome) }}: {{ item.tel }}</a>
                            </li>
                        </ul>
                    </li>
                    <!-- POLITICA DE PRIVACIDADE -->
                    <!--<li @click="goToURL('/static/pages/politicaprivacidade.html')">-->
                    <li @click="goToPagina('mPolitica')">
                        <a href="/mPolitica" style="font-family: 'Humanst521BT'; pointer-events: none;">{{ getInterText(inter_ind.politica_privacidade) }}</a>
                    </li>
                </ul>

                <!-- POLITICA DE PRIVACIDADE -->
                <!--<div v-if="estabs.length>0" class="tx_parceiros" style="display: flex; flex-direction: column; justify-content: center; color: white">-->
                    <!--<a style="font-size: 4vw;" href="/static/pages/politicaprivacidade.html"><span>&nbsp;{{ getInterText(inter_ind.politica_privacidade) }}</span></a>-->
                <!--</div>-->

                <!-- PARCEIROS -->
                <!--<div class="div_pat_m">-->
                    <!--<hr class="hr_pat"/>-->
                    <!--<div style="display: flex;">-->
                        <!--<a v-for="item in barra_pat" :href="item.url" target="_blank"><img :src="item.imgPathW" class="im_pat_m"/></a>-->
                    <!--</div>-->
                <!--</div>-->
            </nav>


            <div v-if="!show10Mais" class="section" id="sidebarCollapse" @click="changeSideBar()">
                <a class="navicon-button x" id="icmenu">
                    <div class="navicon">
                    </div>
                </a>
            </div>

            <div>
                <!-- ################    Top Menu Bar    ################# -->
                <div align="center" class="head0">
                    <div align="center" class="head0_2" :style="show10Mais ? 'background-image: linear-gradient(var(--bg-blue-grad1), var(--bg-blue-grad2))' : 'background: var(--bg-header-color);'">

                        <div class="head1">
                            <!--<img src="/static/imgs/new_meu.png" alt="menu" class="im_menu2" id="sidebarCollapse">-->
                            <img v-if="show10Mais" src="/static/imgs/ic_back_w.png" alt="menu" class="im_menu2" @click="changeShow10Mais()" onMouseOver="this.style.cursor='pointer'">
                            <img v-else src="/static/imgs/advicep_horizontal_small.png" alt="Logo Advice" class="im_logo_small" @click="changeSideBar()">
                        </div>
                        <div class="head2">
                            <span v-if="show10Mais" class="tx_logol2" style="font-size: var(--font-size-title-mobile_2)">{{ getInterText(inter_ind.os) }} 10 +</span>
                            <!--<img v-else src="/static/imgs/advicep_horizontal_small.png" alt="Logo Advice" class="im_logol" @click="homeClear()">-->
                            <span v-else class="tx_title_guia">{{getInterText(inter_ind.seu_guia_turistico)}}</span>
                        </div><div  class="head3">
                            <div class="di_profile_m3" @click="showSearch()" v-if="!show10Mais">
                                <img v-if="showingSearch" src="/static/imgs/ic_lupa_clicked.png" alt="lupa" class="im_profile_m2_square">
                                <img v-else               src="/static/imgs/ic_lupa_.png" alt="lupa" class="im_profile_m2_square" >
                            </div>
                            <div v-if="!user.sucess" class="di_profile_m2" @click="setShowLogin(true)">
                                <img src="/static/imgs/ic_profile2.png" alt="profile" class="im_profile_m2">
                            </div>
                            <div v-if="user.sucess" id="botao_profile1" class="di_profile_m2" @click.stop.prevent="showPopEscritorio()">
                                <div v-if='user.foto === ""' class="im_profile_m2" style="justify-content: center; align-items: center; background-color: var(--bg-blue)">
                                    <span class="tx_initials" >{{ getInitials(user) }}</span>
                                </div>
                                <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile_m2">
                                <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im_profile_m2">
                            </div>
                            <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                                <div class="arrow_top2" style="margin-right: 6vh;"></div>
                                <span class="tx_login_b" >{{ getFirstAndLastWords(user.nome) }}</span>
                                <div class="tx_login" @click.prevent.stop="goToMinhaPagina()">
                                    <span class="tx_login" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.minha_conta) }}</span>
                                </div>
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('mEditUser')">{{ getInterText(inter_ind.configuracoes) }}</span>
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- ################    Busca    ################# -->
                    <div id="search_s_id" class="search0" v-if="showingSearch">
                        <img src="/static/imgs/ic_back_.png" alt="lupa" class="search_lupa" @click="showSearch()">
                        <input ref="search_i" type="text" v-on:keyup.enter="closeKey()" onsubmit="closeKey()" class="search1"  v-on:keyup="getEstabsSearch()" v-model="search_text" :placeholder="getInterText(inter_ind.pesquisar) + '...'"/>
                    </div>


                </div>



                <!-- ################    Banner    ################# -->
                <!--<div class="di_banner">-->
                    <!--<img v-if="search_text.length==0" src="/static/imgs/banner.jpg" alt="banner" class="banner">-->
                <!--</div>-->



                <!-- ################    Panorama    ################# -->
                <div class="panoramica" v-if="search_text.length < minSearchLen && !show10Mais" style="padding-left: 0px">
                    <!--<img src="/static/imgs/panoramica03.jpg" alt="panoramica" class="im100_search">-->
                    <!--<img v-if="" :src="pano[panoInd].imgPath" alt="panoramica" class="im100_search" :style="'top: -'+ pano[panoInd].shift_m +'px;'">-->
                    <img v-if="" :src="pano[panoInd].imgPath" alt="panoramica" class="im100_search" :style="'width: ' + (100 + pano[panoInd].shift_m) + '%;'">

                </div>
                <div v-else style="height: var(--top-bar-heigth);"/>
                <br v-if="search_text.length < minSearchLen && !show10Mais">



                <!-- ################    Loading    ################# -->
                <!--<div v-if="loading.cats" style="text-align: center;" >-->
                    <!--&lt;!&ndash;<span class="btn btn-primary btn-sm"  onMouseOver="this.style.cursor='pointer'">Carregar Mais...</span>&ndash;&gt;-->
                    <!--<img src="/static/imgs/loading5.gif" class="im_loading">-->
                    <!--&lt;!&ndash;<img src="/static/imgs/loading2.gif" class="im_loading">&ndash;&gt;-->
                    <!--<br>-->
                    <!--<br>-->
                    <!--<br>-->
                <!--</div>-->


                <!-- ################    Categorias    ################# -->
                <div class="scrollhorizontal">
                    <div v-for="(item, index) in cats_full" class="di_categoria" @click="atualizaEstabs(item.id, true)" v-if="(!show10Mais && index > 0) || index > 0">
                        <div class="im_categoria2_d" v-if="item.id != cat.id">
                            <img :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" alt="categorias" class="im_categoria2" style="filter: url(#colorize2);"/>
                        </div>
                        <div class="im_categoria2_d" v-if="item.id == cat.id" style="background-color: var(--bg-blue-circle);">
                            <img :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" alt="categorias" class="im_categoria2" style="margin-top: 7.5px;"/>
                            <img src="/static/imgs/ic_ball_bright.png" alt="categorias" class="im_categoria2" style="width: 54px; height: 54px; margin-top: -47.5px;"/>
                        </div>
                        <span class="tx_categoria"> {{ getInterCatName(item) }} </span>
                    </div>
                </div>


                <!--<div class="notranslate" style="font-weight: bold; background-color: pink; display: flex; flex-direction: column;">-->
                    <!--<span @click='changeIdioma(2)'>traduzirEN</span>-->
                    <!--<span @click='changeIdioma(3)'>traduzirES</span>-->
                <!--</div>-->

                <hr style="width: 95%; margin-bottom: 0; padding-bottom: 0.5vh; padding-top: 0; margin-top: 0.5vh"/>

                <div style="display: flex; justify-content: flex-end; height: 3.1vh; width: auto;">
                    <!-- Filtro Cidades -->
                    <div class="custom-select-filtro" style="display: flex; border-radius: 5px; margin-top: 0; margin-right: 1.5%; height: 3.1vh; width: auto; padding-right: 1vh; padding-left: 3%; align-items: center;">
                        <span style="font-size: 2vh">{{city_full[cityIndex].nome}}</span>
                        <!--<span v-else style="font-size: 2vh">{{city_full[cityIndex].nome}} ({{ city_full[cityIndex].quant }})</span>-->
                        <img class="arrow-container_img" src="/static/imgs/ic_down.png" style="object-fit: contain;">
                        <!--<div class="arrow-container" style="pointer-events: none;">-->
                            <!--<div class="arrow arrow-down_b"/>-->
                        <!--</div>-->
                    </div>
                </div>
                <div style="display: flex; justify-content: flex-end; height: 3.1vh; margin-top: -3.1vh;">
                    <!-- Filtro Cidades -->
                    <div class="custom-select-filtro" style="width: 40%; border-radius: 5px; margin-top: 0; margin-right: 0; height: 3.1vh; background-color: unset; color: transparent;">
                        <select id="sel_cats" @change="changeCity($event)" v-model="cityIndex" style="height: 2.9vh; background-color: unset;">
                            <option value="0" v-if="city_full.length > 0"> {{ city_full[0].nome }} </option>
                            <option v-for="(item, index) in city_full" :value="index" v-if="index > 0"> {{ item.nome }} ({{ item.quant }}) </option>
                        </select>
                        <!--<img src="/static/imgs/ic_down.png" style="width: 5%; margin-right: 3%; object-fit: contain;">-->
                    </div>
                </div>

                <!-- ################    Title    ################# -->
                <!--<div v-if="cats_full!=null && cats_full.length>0" class="title" :style="'background-color: ' + cat.cor + ';'">-->
                    <!--<span :style="'color: ' + cat.cor2 + ';'">{{ cat.nome }}</span>-->
                <!--</div>-->
                <div v-if="cats_full!=null && cats_full.length>0" class="title">
                    <img onerror="tryReloadImages(this)" v-if="cat.id>=0" :src="baseUrlImg + 'CATEGORIA/' + cat.imgPath2" alt="categorias" class="im_categoria3" style="filter: url(#colorize2);"/>
                    <img onerror="tryReloadImages(this)" v-if="cat.id==-1"  src="/static/imgs/ic_lupa.png" alt="categorias" class="im_categoria3"/>
                    <span v-if="!hasSubCatsID(cat.id)" class="tx_filtro_cat" style="flex-grow: 1; font-size: 2.5vh;" >{{ getInterCatName(cat) }}</span>
                    <!-- SubCats -->
                    <div v-else style="display: flex; flex-direction: column; flex-grow: 1;">
                        <div class="custom-select-filtro_cat_div">
                            <span v-if="subCatIndex == 0" class="tx_filtro_cat"> {{ subCatText }}</span>
                            <span v-else class="tx_filtro_cat_sel"> {{ subCatText }}</span>
                            <!--<div class="arrow-container">-->
                                <!--<div class="arrow arrow-down"/>-->
                            <!--</div>-->
                            <img class="arrow-container_img" src="/static/imgs/ic_down_blue.png" style="object-fit: contain; margin-left: 0.4vh;">
                        </div>
                        <div class="custom-select-filtro_cat_div" style="margin-top: -4.3vh;">
                            <select class="custom-select-filtro_cat" id="sel_subcat" @change="changeSubCat($event)" v-model="subCatIndex" >
                                <option :value="0"> {{ getInterCatName(cat) }} </option>
                                <option v-for="(item, index) in getSubCat(cat.id)" :value="index + 1"> {{ item }} </option>
                            </select>
                        </div>
                    </div>
                    <!--<img src="/static/imgs/ic_pontos.png" alt="opcoes" class="im_pontos"/>-->
                </div>


                <!-- ################    Estabelecimentos por Search    ################# -->
                <!-- ################    Lista Estabelecimentos    ################# -->
                <div v-if="!show10Mais" class="di_estabelecimento0" v-for="(item, index) in estabs">
                    <!--<span>Tamanho: {{ estabs.length }} index: {{ index }}</span>-->

                    <!-- EMPTY STAB -->
                    <div class="di_estabelecimento1" v-if="index <= config2.endfor && item.id == -1">
                        <div class="di_estabelecimento2 animated-background" style="height: 70vw; background-color: var(--empty-color);">
                        </div>
                        <div style="display: flex; padding-left: 2vw;">
                            <div style="display: flex; flex-direction: column; justify-content: space-evenly; width: 84%; margin-top: 1vh;">
                                <span class="animated-background" style="font-weight: bold; font-size: 2.4vh; background-color: var(--empty-color); color: var(--empty-color)">&nbsp;</span>
                                <!--// DESTAQUES = 53 ;  FAVORITOS = 67-->
                                <div style="display: flex; flex-direction: row; flex-wrap: wrap; font-size: 2.2vh; margin-bottom: 0.5vh;">
                                    <!--<div v-if="cat.id == 53 || cat.id == 67" style="display: flex; flex-direction: row; flex-wrap: wrap;">-->
                                    <div style="width: 50%;">
                                        <!--{{ getCatsStr(item) }}-->
                                        <span class="animated-background" style="display: inline-flex; background-color: var(--empty-color); color: var(--empty-color); width: 100%; font-size: 1.7vh ">&nbsp;</span>
                                    </div>
                                </div>
                                <!--<br>-->

                                <div style="display: flex; flex-direction: row; align-items: center;">
                                    <div class="animated-background" style="width: 16.1vw; height: 4vw; display: flex; position: relative; background-color: var(--empty-color);">
                                        &nbsp;
                                    </div>
                                </div>
                            </div>

                            <!--<div style="display: flex; width: 15%; align-items: center; justify-content: center; background-color: red;">-->
                            <div style="display: flex; align-items: center; justify-content: center; width: 15%; flex-direction: column; margin-top: 1vh; cursor: pointer;">
                                <div style="display: flex; justify-content: center; margin-bottom: 0.7vw;">
                                    <span class="animated-background" style="font-size: 2.4vw; width: 10vw; text-align: center; background-color: var(--empty-color); color: var(--empty-color)">fav</span>
                                </div>
                                <div>
                                    <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="favoritos" class="im_fav_m_h animated-background" style="background-color: var(--empty-color)"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- NORMAL STAB -->
                    <div class="di_estabelecimento1" v-else-if="index <= config2.endfor && item.tbFotos[0]!=null">
                        <div class="di_estabelecimento2"  @click.prevent.stop="goToEstab(item.id)">
                            <img onerror="tryReloadImages(this)" v-if="item.tbFotos!=null" :src="baseUrlImg + '/MARCADOR/' + item.tbFotos[0].file" alt="Foto Principal" class="imgDestaques"/><br>
                        </div>
                        <!--<img src="/static/imgs/ic_selo10.png" style="position: absolute; top: 2vh; right: 2vh; object-fit: scale-down; width: 5vh; height: 5vh; "/>-->
                        <div style="display: flex; padding-left: 2vw;">
                            <div style="display: flex; flex-direction: column; justify-content: space-evenly; width: 84%; margin-top: 1vh;"  @click.prevent.stop="goToEstab(item.id)">
                                <span style="font-weight: bold; font-size: 2.4vh;" v-html="decodeChars(item.nome)"></span>
                                <!--// DESTAQUES = 53 ;  FAVORITOS = 67-->
                                <div style="display: flex; flex-direction: row; flex-wrap: wrap; font-size: 2.2vh; margin-bottom: 0.5vh;">
                                <!--<div v-if="cat.id == 53 || cat.id == 67" style="display: flex; flex-direction: row; flex-wrap: wrap;">-->
                                    <div>
                                        <!--{{ getCatsStr(item) }}-->
                                        <span v-html="decodeChars(item.cidade)"></span>
                                    </div>
                                </div>
                                <!--<br>-->

                                <div style="display: flex; flex-direction: row; align-items: center;">
                                    <div class="di_star_wrap" style="with: 16.1vw; max-width: 16.1vw; height: 3vw;" :title="getInterText(inter_ind.avaliacao) + ((item.avaliacao * 100)/5.0)">
                                        <div alt="estrelas" class="im_star" :style="'width: ' + ((item.avaliacao * 100)/5.0) + '%; height: 3vw;'" align="right"/>
                                    </div>
                                    <!--<img v-if="isFavorite(item.id)" src="/static/imgs/ic_favoritos.png" alt="favoritos" class="im_fav_mpagina" style="margin-left: 1vw; width: 3.1vw; object-fit: contain;" onMouseOver="this.style.cursor='pointer'" @click="sendFavoriteAvaliacao(item.id, -1)" />-->
                                    <!--<img v-else src="/static/imgs/ic_favoritos_not.png" alt="favoritos" class="im_fav_mpagina" style="margin-left: 1vw; width: 3.1vw; object-fit: contain;" onMouseOver="this.style.cursor='pointer'" @click="sendFavoriteAvaliacao(item.id, -1)" />-->
                                </div>
                            </div>

                            <!--<div style="display: flex; width: 15%; align-items: center; justify-content: center; background-color: red;">-->
                            <div style="display: flex; align-items: center; justify-content: center; width: 15%; flex-direction: column; margin-top: 1vh; cursor: pointer;">
                                <div style="display: flex; justify-content: center; margin-bottom: 0.7vw;" @click.prevent.stop="sendFavoriteAvaliacao(item.id, -1)">
                                    <span style="font-size: 2.4vw; width: 16vw; text-align: center;"> {{ getInterText(inter_ind.favoritos) }} </span>
                                </div>
                                <div>
                                    <img v-if="user.tipo == 1" src="/static/imgs/ic_edit_sq.png" alt="favoritos" class="im_fav_m_h" @click.prevent.stop="goToEditPage(item, 'm')"/>
                                    <img v-if="loading.favorito" src="/static/imgs/loading6.gif" alt="Carregando" class="im_fav_m_h">
                                    <img v-else-if="!loading.favorito && isFavorite(item.id)" src="/static/imgs/ic_favoritos.png" alt="favoritos" class="im_fav_m_h" @click.prevent.stop="sendFavoriteAvaliacao(item.id, -1)"/>
                                    <img v-else src="/static/imgs/ic_favoritos_not.png" alt="favoritos" class="im_fav_m_h" @click.prevent.stop="sendFavoriteAvaliacao(item.id, -1)"/>
                                </div>

                            </div>

                        </div>

                        <hr v-if="isAdIndex(index)" style="border-color: transparent; background-color: unset; margin-bottom: 0;"/>
                        <hr v-else style="border-color: transparent; background-color: unset; margin-bottom: 2vh;"/>
                    </div>

                    <!--{{ isAdIndex(index) }}-->
                    <!-- ADVERTISEMENT STAB -->
                    <div v-if="isAdIndex(index) && index <= config2.endfor" class="di_estabelecimento1">
                        <span class="tx_ad_pat">{{getInterText(inter_ind.patrocinado)}}</span>
                        <div class="di_estabelecimento2"  @click.prevent.stop="goToURL(ads[getAdIndex(index)].link)">
                            <img onerror="tryReloadImages(this)" :src="ads[getAdIndex(index)].img" alt="Foto Principal" class="imgDestaques"/><br>
                        </div>
                        <hr style="border-color: transparent; background-color: unset; margin-bottom: 1vh;"/>
                    </div>

                </div>




                <!-- ################    Lista Estabelecimentos  10+  ################# -->
                <div v-if="show10Mais && item.is10Mais" class="di_estabelecimento0_2" v-for="(item, index) in estabs">
                    <!--<span>Tamanho: {{ estabs.length }} index: {{ index }}</span>-->
                    <div class="di_estabelecimento1_2" v-if="item.tbFotos[0] != null && item.is10Mais" @click.prevent.stop="goToEstab(item.id)">

                        <div class="di_estabelecimento2_2">
                            <!--<router-link :to="{ query: { id: item.id }, params: { stabs: estabs_full, categs: cats_full}, name: 'mEstabelecimento'}" style="height: 100%;">-->
                                <img onerror="tryReloadImages(this)" v-if="item.tbFotos!=null" :src="baseUrlImg + '/MARCADOR/' + item.tbFotos[0].file" alt="Foto Principal" class="imgDestaques"/><br>
                            <!--</router-link>-->
                        </div>

                        <div style="display: flex; width: 66%; padding-left: 0vw; background-image: url('/static/imgs/ic_triangulo.png'); background-size: 4vh 4vh; background-repeat: no-repeat;">
                            <span style="color: white; display: flex; flex-wrap: nowrap; margin-left: 0.5vh; font-size: 1.5vh;"> {{ index + 1 }}&ordm; </span>
                            <div style="display: flex; flex-direction: column; margin-left: 1vw; justify-content: space-evenly; width: 79%; align-content: center; justify-content: center;">
                                <span style="font-weight: bold;" v-html="decodeChars(item.nome)"></span>
                                <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
                                    <div style="display: flex;" >
                                        <!--{{ getCatsStr(item) }}-->
                                        <span v-html="decodeChars(item.cidade)"></span>
                                    </div>
                                </div>

                                <div style="display: flex; flex-direction: row; align-items: center; height: 2vh ">
                                    <!--<div class="di_star_wrap" style="with: 16.1vw; max-width: 17.1vw; height: 3.1vw;" :title="getInterText(inter_ind.avaliacao) + item.avaliacao">-->
                                    <div class="di_star_wrap" style="with: 8.05vh; max-width: 8.6vh; height: 1.6vh;" :title="getInterText(inter_ind.avaliacao) + ((item.avaliacao * 100)/5.0)">
                                        <div alt="estrelas" class="im_star" :style="'width: ' + ((item.avaliacao * 100)/5.0) + '%; height: 100%;'" align="right"/>
                                    </div>
                                    <img v-if="isFavorite(item.id)" src="/static/imgs/ic_favoritos.png" alt="favoritos" class="im_fav_mpagina" style="margin-left: 1vw; width: auto; object-fit: contain; height: 100%; cursor: pointer;" @click.prevent.stop="sendFavoriteAvaliacao(item.id, -1)" />
                                    <img v-else src="/static/imgs/ic_favoritos_not.png" alt="favoritos" class="im_fav_mpagina" style="margin-left: 1vw; width: auto; object-fit: contain; height: 100%; cursor: pointer;" @click.prevent.stop="sendFavoriteAvaliacao(item.id, -1)" />
                                </div>
                            </div>
                            <div v-if="item.is10Mais" style="display: flex; width: 20%; align-items: center; justify-content: center;">
                                <img src="/static/imgs/ic_selo10.png" style="object-fit: scale-down; width: 4vh; height: 4vh; "/>
                            </div>
                        </div>
                    </div>
                </div>





                <div v-if="estabs.length==0 && !loading.cats && search_text.length==0">
                    <br>
                    <span style="text-align: center"><h4>{{ getInterText(inter_ind.nenhum_estabelecimento) }}</h4></span>
                    <br><br><br>
                </div>
                <div v-if="search_text.length >= minSearchLen && estabs.length==0">
                    <br>
                    <span style="text-align: center"><h4>{{ getInterText(inter_ind.nenhum_resultado) }}</h4></span>
                    <br><br><br>
                </div>
                <div v-if="search_text.length>0 && search_text.length < minSearchLen">
                    <br>
                    <span style="text-align: center"><h4>{{ getInterText(inter_ind.utilize_pelo_menos) }}&nbsp;{{ minSearchLen }}&nbsp;{{ getInterText(inter_ind.caracteres) }}.</h4></span>
                    <br><br><br>
                </div>
                <!--{{ scrollAtual }} maior que {{ scrollMax }}<br>-->
                <!-- -1 porque o no ultimo elemento nao bota o loading no final-->
                <div v-if="config2.endfor < estabs.length-1 && !show10Mais" style="text-align: center; margin-top: -15vh;">
                    <!--<span class="btn btn-primary btn-sm"  onMouseOver="this.style.cursor='pointer'">Carregar Mais...</span>-->
                    <img v-if="showLoadingEstabs" src="/static/imgs/loading6.gif" class="im_loading">
                    <img v-if="!showLoadingEstabs" @click="initCarregarMais()" src="/static/imgs/loading6.gif" onMouseOver="this.style.cursor='pointer'" class="im_loading">
                    <br>
                    <br>
                    <br>
                </div>


            </div>
        </div>

        <horizontal-msg/>

        <!--Barra de rodapé -->
        <div id="div_parceiros" class="div_pat" v-if="estabs.length > 0" style="margin-top: 0vh; margin-bottom: 5vh; width: 100%; margin-bottom:0%;">
            <span class="tx_parceiros" style="font-size: 1.3em; margin-bottom: -15%;">{{ getInterText(inter_ind.parceiros) }}</span><br>
            <div class="parceiros-container" style="margin-top: -10%">
                <a v-for="item in barra_pat" :href="item.url" target="_blank" class="parceiro-item">
                    <img
                        onerror="tryReloadImages(this)"
                        :src="item.imgPath"
                        :class="['im_pat', { 'im_pat_mangabeira': item.imgPath.includes('mangabeira'),'im_pat_jcarneiro': item.imgPath.includes('jcarneiro') }]"
                    />
                </a>
            </div>
        </div>

        <div id="div_whatsapp" v-if="estabs.length>0" class="tx_parceiros" style="display: flex; flex-direction: row; justify-content: center; padding-bottom: 1vw;">
            <a style="display: flex; justify-content: center; align-items: center" href="https://wa.me/+558393625402?text=Ol%C3%A1%20Advice" target="_blank"><span>Fale conosco - (83) 99362-5402</span><img src="/static/imgs/ic_whats.png" style="width: 20px; height: 20px; object-fit: scale-down;"/></a>
        </div>
        <div id="div_politica" v-if="estabs.length>0" class="tx_parceiros" style="display: flex; flex-direction: row; justify-content: center; padding-bottom: 0.5vh;">
            <span>&copy; {{ getYear() }} Advice Paraíba |</span>
            <a href="/mPolitica" ><span>&nbsp;{{ getInterText(inter_ind.politica_privacidade) }}</span></a>
        </div>


        <div class="div_getPhone" v-if="showGetPhone" @click="getPhoneSair()">
            <div class="getPhone_parts" @click.stop.prevent="nada()">
                <img src="/static/imgs/advicep_horizontal.png" alt="logo advice" class="im10">

                <div style="display: flex; flex-direction: row; width: 100%; justify-content: center; align-items: center;">
                    <img v-if='hasHttp(new_user.foto)'  :src='new_user.foto' alt="profile" class="im_profile_m2">
                    <img v-else :src='baseUrlImg + "PROFILE/" + new_user.foto'     alt="profile" class="im_profile_m2">
                    <span class="getPhone_txt" style="margin-left: 1%;">{{ new_user.nome }}</span>
                </div>
                <span class="getPhone_txt" style="margin-bottom: 2vh; cursor: pointer;" @click="getPhoneSair()">Não é você? <strong>Sair.</strong></span>

                <span class="getPhone_txt">Digite o seu contato para finalizarmos o seu cadastro.</span>
                <div class="getPhone_input_box">
                    <img src="/static/imgs/ic_tel3.png" style="height: 80%;"/>
                    <input id="telefoneid" class="input_name_getPhone" type="text" v-model="editing[2].texto" v-on:keyup="mphone(editing[2])"/>
                </div>
                <span class="getPhone_txt">O seu telefone não ficará visível para outros usuários.</span>

                <div style="display: flex; flex-direction: row; width: 100%; justify-content: space-evenly;">
                    <span class="tx_login4_c" @click="getPhoneSair()">{{ getInterText(inter_ind.cancelar) }}</span>
                    <span class="tx_login4" @click="submitformUserUserPhone()">{{ getInterText(inter_ind.enviar) }}</span>
                </div>
            </div>
        </div>

        <div id="btn_topo" v-if="showGoToTop" @click="goToTop" class="topo-button">
            <img src="/static/imgs/advice_seta.png" style="width: 100%; height: auto; object-fit: contain; padding-right: 10%; padding-left: 10%;" />
            <span class="noselect" style="color: var(--blue-text); font-size: 1vh; text-align: center;">TOPO</span>
        </div>






        <!-- Show Cookies -->
        <div class="div_cookie_c_m" v-if="cookies_geral.showCookies">
            <div class="div_cookie_m unselectable">
                <span class="tx_check unselectable" style="display: block; text-align: left; color: var(--blue-text);">{{ getInterText(inter_ind.texto_cookies_inicio) }}&nbsp;<a href="/mPolitica" class="unselectable" style="font-weight: bold">{{ getInterText(inter_ind.politica_privacidade) }}.</a></span>

                <!-- Botao Ok -->
                <div class="div_botao_white_blue" style="margin-top: 4vw;" @click="setShowCookies(false)">
                    <span class="tx_continuar unselectable">Ok</span>
                </div>
            </div>
        </div>

        <div class="div_login_m" v-if="showLogin" >
            <div class="parts_m">
                <div style="display: flex; justify-content: flex-end; width: 100%;" @click="setShowLogin(false)">
                    <img src="/static/imgs/bt_fechar_w.png" class="im_close_w" onMouseOver="this.style.cursor='pointer'">
                </div>

                <div style="text-align: center; margin-top: 5vh;">
                    <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="height: 8vh">
                </div>

                <!--<div class="div_face_w" style="margin-top: 10vh;" @click="externalLoginFace_checkLoginState()">-->
                    <!--<div class="div_faceim">-->
                        <!--<img src="/static/imgs/ic_face_blue.png" alt="facebook" class="im_face">-->
                    <!--</div>-->

                    <!--<div class="div_facetx">-->
                        <!--<span class="tx_face_m"> {{ getInterText(inter_ind.entre_face) }} </span>-->
                    <!--</div>-->
                <!--</div>-->

                <!--Login Google-->
                <div v-if="!isiOS()" class="div_face_w" style="margin-top: 8vh; margin-bottom: 3vh" @click="externalLoginGoogle_startApp()">
                    <div class="div_faceim">
                        <img src="/static/imgs/ic_google.png" alt="login google" class="im_face">
                    </div>

                    <div class="div_facetx">
                        <span class="tx_face_m unselectable"> {{ getInterText(inter_ind.entre_google) }} </span>
                    </div>
                </div>
                <div v-else style="height: 12vh;"/>

                <!--Login Apple-->
                <!--<div v-if="!isiOS()" class="div_face_w" style="margin-bottom: 5vh" @click="loginAppleStart()">-->
                    <!--<div class="div_faceim" style="padding: 1px;">-->
                        <!--<img src="/static/imgs/ic_apple_b.png" alt="login apple" class="im_face" style="object-fit: scale-down;">-->
                    <!--</div>-->

                    <!--<div class="div_facetx">-->
                        <!--<span class="tx_face_m unselectable" style="color: #333333;"> {{ getInterText(inter_ind.entre_apple) }} </span>-->
                    <!--</div>-->
                <!--</div>-->

                <div class="div_nome_l">
                    <!--<span class="tx_nome_before_w" @click="clickInput(1, true)" v-if="!editing[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>-->
                    <!--<div class="hr_w" @click="clickInput(1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[1].status"/>-->
                    <span class="tx_nome_w" v-if="editing[1].status">E-mail</span>
                    <input id="emailid" :class="editing[1].status ? 'input_name_w' : 'input_name_w_d'" type="text" v-model="editing[1].texto" tabindex="3" placeholder="E-mail" @click="clickInput(1, true)" autocapitalize="none"/>
                    <span v-if="!checkEmail(editing[1].texto) && editing[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome_l">
                    <!--<span class="tx_nome_before_w" @click="clickInput(0, true)" v-if="!editing[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>-->
                    <!--<div class="hr_w" @click="clickInput(0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[0].status"/>-->
                    <span class="tx_nome_w" v-if="editing[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <div style="display: flex; flex-direction: row;">
                        <input id="nameid" :class="editing[0].status ? 'input_name_w' : 'input_name_w_d'" :type='editing[0].show ? "text" : "password"' v-model="editing[0].texto" :placeholder="getInterText(inter_ind.senha)" tabindex="4" v-on:keyup.enter="tryLogin()" @click="clickInput(0, true)"/>
                        <img v-if="editing[0].status" :src='editing[0].show ? "/static/imgs/ic_eye_open_w.png" : "/static/imgs/ic_eye_close_w.png"' style="width: 6vw; object-fit: contain;" @click="showPass(0)">
                    </div>
                    <span v-if="!checkPass(editing[0].texto) && editing[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada_2) }}</span>
                </div>


                <div class="div_check" style="margin-top: 2vh;">
                    <span class="tx_check" style="cursor: pointer;" @click="goToEditUser">{{ getInterText(inter_ind.esqueceu_senha) }}</span>
                </div>
                <div class="div_check" style="margin-top: 1vh;">
                    <div class="div_check_in" @click="changeCheckState(0)">
                        <span v-if="valid.enterAuto" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check" style="flex-grow: 1; text-align: left;">{{ getInterText(inter_ind.entrar_auto) }}</span>
                </div>

                <span v-if="senhaErrada" class="error_msg"> {{ getInterText(inter_ind.senha_errada) }} </span>
                <div style="text-align: center;">
                    <span v-if="userNaoCadastrado" class="error_msg"> {{ getInterText(inter_ind.usuario_nao_cadastrado) }}</span>
                </div>
                <span v-for="item in msg_erros" class="error_msg" style="margin-left: 20px;"> * {{ item }} <br/> </span>

                <img v-if="loading.user || loading.apple || loading.google" src="/static/imgs/loading6.gif" alt="Carregando" class="im_loading_up">

                <div style="display: flex; flex-direction: row; margin-top: 10vh">
                    <div class="div_botao_login" style="margin-right: 2vw; background-color: white;" @click="tryLogin()" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                        <span class="tx_continuar unselectable" style="color: var(--bg-blue);"> {{ getInterText(inter_ind.entrar) }} </span>
                    </div>
                    <!--<router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat}, name: 'mRegisterUser'}">-->
                        <div class="div_botao_login" @click="goToPagina('mRegisterUser')">
                            <span class="tx_continuar_w unselectable" > {{ getInterText(inter_ind.cadastre) }} </span>
                        </div>
                    <!--</router-link>-->
                </div>
            </div>
        </div>

        <filter id="colorize" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.18
                 0 0 0 0 0.24
                 0 0 0 0 0.31
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize2" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.058
                 0 0 0 0 0.384
                 0 0 0 0 0.674
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_blue" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.0625
                 0 0 0 0 0.375
                 0 0 0 0 0.672
                 0 0 0 1 0"/>
        </filter>

        <Alert v-if="showAlert || showConfirm" :textProp="textAlert" :confirmProp="showConfirm" @emit-close="closeAlert" @emit-action="actionFunction"/>

        <div class="overlay" @click="changeSideBar()"></div>

    </div>
</template>

<script>
    import axios from 'axios'
    import { advMixin } from '../scripts/advMixin'
    import Vue from 'vue'
    import MenuBar from '@/components/templates/MenuBar.vue'

    //Vue.mixin(advMixin);

    export default {
        mixins: [advMixin],
        name: 'mHome',
        data () {
            return {
                name: 'mHome',
                // scrollAtual: 0,
                // scrollMax: 0,
                scrollYOld: 0,
                showLoadingEstabs: false,
                docHeightOld: 0,
                estabs: [],
                estabs_back: [],
                cats: [],
                // estabs_full: [],
                estabs_full: [
                    {
                        "id": -1,
                        "descricao2": "Gelato Gourmet - A Due Amori vem com a inova&ccedil;&atilde;o acompanhada de sofistica&ccedil;&atilde;o e bom gosto ao Gelato Italiano",
                        "telresponsavel": "(83) 3024-3409",
                        "cep": "58037-700",
                        "rua_num": "Rua Severino Nicolau de Melo",
                        "numero": "163",
                        "bairro": "Jardim Oceania",
                        "cidade": "João Pessoa",
                        "estado": "PB",
                        "complemento": "",
                        "exibir": true,
                        "nome": "Due Amore Gelateria",
                        "nomeSimple": "dueamoregelateria",
                        "telefones": "(83) 3024-3409",
                        "email": "",
                        "video_link": "",
                        "site": "",
                        "site2": "",
                        "subcat": "",
                        "avaliacao": 0,
                        "investimento": 2,
                        "horario": "",
                        "deleted": false,
                        "ativo": true,
                        "aprovado": true,
                        "tbCategoriaEstabelecimentos": [
                            {
                                "id": 62
                            },
                            {
                                "id": 73
                            },
                            {
                                "id": 56
                            },
                            {
                                "id": 57
                            },
                            {
                                "id": 58
                            },
                            {
                                "id": 74
                            },
                            {
                                "id": 75
                            }
                        ],
                        "tbTrajeEstabelecimentos": [],
                        "tbFotos": [
                            {
                                "id": 2145,
                                "file": "rd7209h06w.jpg",
                                "ordem": 0
                            }
                        ],
                        "tbComentarios": [],
                        "tbLocal": {
                            "id": 1,
                            "nome": "Advice Paraíba",
                            "dtAlteracao": "Jun 9, 2018 6:40:45 PM"
                        },
                        "idUsuario": 5,
                        "tbSituacaoEstabelecimento": {
                            "id": 1,
                            "nome": "Normal"
                        },
                        "responsavel": "undefined"
                    },
                    {
                        "id": -1,
                        "descricao2": "XXXXX",
                        "telresponsavel": "(83) 3024-3409",
                        "cep": "58037-700",
                        "rua_num": "Rua Severino Nicolau de Melo",
                        "numero": "163",
                        "bairro": "Jardim Oceania",
                        "cidade": "João Pessoa",
                        "estado": "PB",
                        "complemento": "",
                        "exibir": true,
                        "nome": "XXX",
                        "nomeSimple": "dueamoregelateria",
                        "telefones": "(83) 3024-3409",
                        "email": "",
                        "video_link": "",
                        "site": "",
                        "site2": "",
                        "subcat": "",
                        "avaliacao": 0,
                        "investimento": 2,
                        "horario": "",
                        "deleted": false,
                        "ativo": true,
                        "aprovado": true,
                        "tbCategoriaEstabelecimentos": [
                            {
                                "id": 62
                            },
                            {
                                "id": 73
                            },
                            {
                                "id": 56
                            },
                            {
                                "id": 57
                            },
                            {
                                "id": 58
                            },
                            {
                                "id": 74
                            },
                            {
                                "id": 75
                            }
                        ],
                        "tbTrajeEstabelecimentos": [],
                        "tbFotos": [
                            {
                                "id": 2145,
                                "file": "rd7209h06w.jpg",
                                "ordem": 0
                            }
                        ],
                        "tbComentarios": [],
                        "tbLocal": {
                            "id": 1,
                            "nome": "Advice Paraíba",
                            "dtAlteracao": "Jun 9, 2018 6:40:45 PM"
                        },
                        "idUsuario": 5,
                        "tbSituacaoEstabelecimento": {
                            "id": 1,
                            "nome": "Normal"
                        },
                        "responsavel": "undefined"
                    }
                ],
                search_text: "",
                showingSearch: false,
                response: {
                    status: "ok"
                },
                panoInd: 0,
                pano: [
                    // {
                    //     imgPath: "static/imgs/pano01.jpg",
                    //     shift: 440,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano02.jpg",
                    //     shift: 420,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano03.jpg",
                    //     shift: 250,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano04.jpg",
                    //     shift: 140,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano05.jpg",
                    //     shift: 300,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano06.jpg",
                    //     shift: 440,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano07.jpg",
                    //     shift: 420,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano08.jpg",
                    //     shift: 250,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano09.jpg",
                    //     shift: 140,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano10.jpg",
                    //     shift: 300,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano11.jpg",
                    //     shift: 440,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano12.jpg",
                    //     shift: 420,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano13.jpg",
                    //     shift: 250,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano14.jpg",
                    //     shift: 140,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano15.jpg",
                    //     shift: 300,
                    //     shift_m: 0
                    // },



                    // {
                    //     imgPath: "static/imgs/pano_d_01.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_02.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_03.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_04.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_05.jpg",
                    //     shift: 0,
                    //     shift_m: 30,
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_06.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_07.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_08.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_09.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },



                    {
                        imgPath: "static/imgs/pano_d2_01.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_02_.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_03.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_04.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_05.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_06.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_07.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_08.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_09.jpg",
                        shift: 0,
                        shift_m: 0
                    }
                ]
            }
        },
        components: {
            MenuBar: MenuBar
        },
        directives: {
            focus: {
                inserted(el) {
                    console.log('chamando o mHome::directives::focus::inserted focus');
                    el.focus();
                    // el.click();
                    // Vue.nextTick(function() {
                    //     el.focus()
                    // })
                },
                // update: function(el, binding) {
                //     console.log('chamando o mHome::directives::focus::update 1');
                //     var value = binding.value
                //     if (value) {
                //         console.log('chamando o mHome::directives::focus::update 2');
                //         Vue.nextTick(function() {
                //             el.focus()
                //         })
                //     }
                // }
            }
        },
        methods: {
            shuffle(array) {
                var tmp, current, top = array.length;
                if(top) while(--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }
                return array;
            },
            goToTop() {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            },
            checkScroll() {
                const topoButton = document.getElementById('btn_topo');
                const patrocinadores = document.getElementById('div_parceiros');
                const patrocinadoresRect = patrocinadores.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                if (patrocinadoresRect.top < windowHeight && patrocinadoresRect.bottom > 0) {
                    // Patrocinadores estão visíveis
                    topoButton.classList.add('hidden');
                } else {
                    // Patrocinadores não estão visíveis
                    topoButton.classList.remove('hidden');
                }
            },
            // sleep time expects milliseconds
            sleep (time) {
                return new Promise((resolve) => setTimeout(resolve, time));
            },
            goToEditUser() {
                window.location.href = 'https://www.adviceparaiba.com/mEditUser';
            },
            homeClear () {
                this.search_text = ''
                this.showingSearch = false;
                this.getEstabsSearch();
                this.atualizaEstabs(this.idCat, true);
                window.scrollTo(0,0);
            },
            goToTop() {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            },
            handleScroll() {
                let windowHeight = window.innerHeight;
                let scrollTop = window.scrollY;
                let divParceiros = document.getElementById('div_parceiros');
                let divWhatsapp = document.getElementById('div_whatsapp');
                let divPolitica = document.getElementById('div_politica');
                
                // Verifica se uma das divs de rodapé está visível
                let isFooterVisible = (div) => {
                    if (!div) return false;
                    let rect = div.getBoundingClientRect();
                    return rect.top < windowHeight && rect.bottom >= 0;
                };

                if (scrollTop > windowHeight && !isFooterVisible(divParceiros) && !isFooterVisible(divWhatsapp) && !isFooterVisible(divPolitica)) {
                    this.showGoToTop = true;
                } else {
                    this.showGoToTop = false;
                }

                // Ajusta a posição do botão "TOPO" se uma das divs de rodapé estiver visível
                let btnTopo = document.getElementById('btn_topo');
                if (btnTopo && (isFooterVisible(divParceiros) || isFooterVisible(divWhatsapp) || isFooterVisible(divPolitica))) {
                    btnTopo.style.bottom = '10%';  // Ajuste conforme necessário
                } else if (btnTopo) {
                    btnTopo.style.bottom = '2%';  // Valor padrão
                }
            },
            initCarregarMais() {
                this.showLoadingEstabs = true;
                // this.sleep(2000).then(() => {
                this.sleep(1000).then(() => {
                    this.carregarMais();
                    this.showLoadingEstabs = false;
                });
            },
            handleScroll()
            {
                // this.scrollAtual = $(document).height();
                // this.scrollMax   = $(window).scrollTop() + $(window).height();

                // Controla exibicao da seta
                if (window.scrollY > window.innerHeight) {
                    this.showGoToTop = true;
                } else {
                    this.showGoToTop = false;
                }

                if (window.scrollY > 0) {
                    // console.log('scrolled win scrollTop ' + $(window).scrollTop());
                    // console.log('scrolled doc scrollTop ' + $(document).scrollTop());
                    // console.log('scrolled win height    ' + $(window).height());
                    // console.log('scrolled doc height    ' + $(document).height());
                    // console.log('scrolled WIN InerHeight' + window.innerHeight);

                    // console.log('scrolled heightOld  ' + this.docHeightOld);
                    // console.log('scrolled hescrollY  ' + window.scrollY);

                    this.scrollYOld = window.scrollY;

                    if(($(window).scrollTop() + $(window).height() > $(document).height()-200) && this.docHeightOld != $(document).height() && this.showLoadingEstabs == false) {
                        this.docHeightOld = $(document).height();

                        //alert("bottom!");
                        // this.sleep(1000).then(() => {
                        this.sleep(500).then(() => {
                            this.initCarregarMais();
                        });
                    }
                }
            },
            carregarMais() {
                this.config2.endfor += this.config2.incfor;

                localStorage.setItem('endfor', '' + this.config2.endfor);
            },
            adjustCaracterEncoding() {
                var i;
                var vm = this;
                for (i=0 ; i<vm.estabs_full.length ; i++) {
                    try {
                        vm.estabs_full[i].nome = decodeURIComponent(escape(vm.estabs_full[i].nome));
                    } catch (e) {
                        vm.estabs_full[i].nome = unescape(vm.estabs_full[i].nome);
                    }
                    try {
                        vm.estabs_full[i].horario = decodeURIComponent(escape(vm.estabs_full[i].horario));
                    } catch (e) {
                        vm.estabs_full[i].horario = unescape(vm.estabs_full[i].horario);
                    }
                    try {
                        vm.estabs_full[i].responsavel = decodeURIComponent(escape(vm.estabs_full[i].responsavel));
                    } catch (e) {
                        vm.estabs_full[i].responsavel = unescape(vm.estabs_full[i].responsavel);
                    }
                    try {
                        vm.estabs_full[i].rua_num = decodeURIComponent(escape(vm.estabs_full[i].rua_num));
                    } catch (e) {
                        vm.estabs_full[i].rua_num = unescape(vm.estabs_full[i].rua_num);
                    }
                    try {
                        vm.estabs_full[i].bairro = decodeURIComponent(escape(vm.estabs_full[i].bairro));
                    } catch (e) {
                        vm.estabs_full[i].bairro = unescape(vm.estabs_full[i].bairro);
                    }
                    try {
                        vm.estabs_full[i].cidade = decodeURIComponent(escape(vm.estabs_full[i].cidade));
                    } catch (e) {
                        vm.estabs_full[i].cidade = unescape(vm.estabs_full[i].cidade);
                    }
                }
            },

            getEstabsSearch() {
                // console.log('getEstabsSearch:antes ' + this.search_text);
                // console.log('getEstabsSearch:search_i ' + this.$refs.search_i.value);

                if (this.search_text.length < this.$refs.search_i.value.length) {
                    this.search_text = this.$refs.search_i.value;
                }

                console.log('getEstabsSearch:depois ' + this.search_text);

                var vm = this;
                // quando esta vindo da pag do Estabelecimento.
                // if (this.search_text.length == 1) {
                if (this.search_text.length > 0) {
                    // this.cat.nome = "Resultado Busca";
                    // this.cat.id = -1;
                    this.$nextTick(function () {
                        vm.$refs.search_i.focus();
                    });
                }

                if (this.search_text.length < this.minSearchLen) {
                    console.log('getEstabsSearch::nao vou buscar');

                    if (this.search_text.length <= this.minSearchLen - 1) {
                        this.estabs = this.estabs_back;
                        console.log('this.cat_back::' + this.cat_back.nome);
                        // se fizer assim da erro, pois vai ser copiada apenas a referencia. E quando alterar o nome para busca vai alterar na variavel original tb.
                        //this.cat = this.cat_back;

                        // this.cat.id = this.cat_back.id;
                        // this.cat.nome = this.cat_back.nome;
                        // this.cat.nomeEn = this.cat_back.nomeEn;
                        // this.cat.nomeEs = this.cat_back.nomeEs;
                        // this.cat.cor = this.cat_back.cor;
                        // this.cat.cor2 = this.cat_back.cor2;
                        // this.cat.imgPath2 = this.cat_back.imgPath2;

                        this.cat = this.copyCat(this.cat_back);

                        if (this.subCatIndex == 0) {
                            this.subCatText = this.getInterCatName(cat);
                            console.log('4::setando o subCatText para: ', this.subCatText);
                        }
                    }
                    return ;
                }

                window.scrollTo(0,0);
                this.cat.nome   = this.inter_pt[this.inter_ind.resultado_busca];
                this.cat.nomeEn = this.inter_en[this.inter_ind.resultado_busca];
                this.cat.nomeEs = this.inter_es[this.inter_ind.resultado_busca];
                this.cat.id = -1;

                this.estabs = [];
                var search_text2 = this.search_text.toLowerCase();
                var i;
                for (i=0 ; i<this.estabs_full.length ; i++) {
                    var estab = this.estabs_full[i];

                    if (estab.nome.toLowerCase().indexOf(search_text2)>=0 ||
                        estab.bairro.toLowerCase().indexOf(search_text2)>=0 ||
                        estab.descricao2.toLowerCase().indexOf(search_text2)>=0) {
                        this.estabs.push(estab);
                        console.log('search: ' + estab.nome);
                    }
                    else {
                        var j;
                        for (j=0 ; j < estab.tbCategoriaEstabelecimentos.length ; j++) {
                            var catt = estab.tbCategoriaEstabelecimentos[j];
                            if (catt.nome.toLowerCase().indexOf(search_text2)>=0) {
                                this.estabs.push(estab);
                                console.log('search: ' + estab.nome);
                                break;
                            }
                        }
                    }

                }
            },



            atualizaParametros() {
                console.log('atualizaParametros');
                console.log('query: ', this.$route.query);
                console.log('params: ', this.$route.params);

                // ID 67 eh de Patrocinados;
                // ID 53 eh de Destaques;
                // ID 62 eh de Turisticos;
                // ID 73 eh de Praias;
                var idCat = 62;

                if (this.$route.query.idCat != null) {
                    idCat = this.$route.query.idCat;
                    console.log('id eh valido ' + idCat);

                } else {
                    if (this.$route.params.idCat != null) {
                        idCat = this.$route.params.idCat;
                        console.log('id eh valido ' + idCat);
                    }
                    else
                    console.log('id eh nulo');
                }

                this.idCat = idCat

                this.getCities();

                this.atualizaEstabs(idCat, false);
            },
        },

        created() {
            console.log(this.name + '::created!!');

            if (this.$route.params.idCat != null) {
                this.idCat = this.$route.params.idCat;
                console.log('setando o idCat para: ', this.idCat);
            }

            // Faz a validacao do e-mail do usuario.
            if (this.$route.query.idu != null && this.$route.query.ver != null) {
                // idu=id_user&ver=verification_code
                this.validadeEmail(this.$route.query.idu, this.$route.query.ver)
            }

            if (this.$route.params.subCatIndex != null) {
                this.subCatIndex = this.$route.params.subCatIndex;
                this.subCatText = this.getSubCats(this.idCat, this.subCatIndex - 1);
                console.log('setando o subCatIndex para: ', this.subCatIndex);
                console.log('1::setando o subCatText para: ', this.subCatText);
            }


            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');

                // se vier do back, entao carrega o endofor que tava sendo usado.
                if (localStorage.getItem('endfor')) {
                    this.config2.endfor = parseInt(localStorage.getItem('endfor'));
                }

                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                if (this.estabs_full.length == 1) {
                    console.log(this.name + '::Baixando estabs!!');
                    this.getEstabsCatsHome();
                }
                else {
                    this.getCities();
                    if (this.$route.params.idCat != null) {
                        console.log('idCat: ', this.idCat);
                        this.idCat = this.$route.params.idCat;
                        console.log('idCat route: ', this.$route.params.idCat);

                        if (this.$route.params.subCatIndex != null) {
                            this.subCatText = this.getSubCats(this.idCat, this.subCatIndex - 1);
                            console.log('2::setando o subCatText para: ', this.subCatText);
                        }
                    }
                    if (this.$route.params.search) {
                        this.search_text = this.$route.params.search;
                        if (this.search_text.length > 0) {
                            this.showingSearch = true;
                        }
                    }

                    if (this.$route.params.indexCity != null) {
                        this.cityIndex = this.$route.params.indexCity;
                        console.log('setando o cityIndex para: ', this.cityIndex);
                    }

                    console.log('this.$route.params.dezMais: ', this.$route.params.dezMais);
                    if (this.$route.params.dezMais != null)
                        this.show10Mais = this.$route.params.dezMais;
                    this.atualizaParametros();
                }
            }
            else {
                console.log(this.name + '::Baixando estabs!!');
                this.atualizaParametros();
                this.getEstabsCatsHome();
            }

            if (this.$route.params.anuncios) {
                console.log('Usando anuncios passados por parametro!!');
                this.anuncios = this.$route.params.anuncios;
            }
            else {
                console.log('Baixando estabs!!');
                this.getAnuncios();
            }

            // atualiza lista de cidades.
            // console.log('Cidades:');
            // this.getCities();
            // console.log(this.city_full);

            console.log(this.name + '::Terminei o created!!');
        },

        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },

        /*
        mounted() {
            console.log('mounted mHome!! idioma', this.user.idioma);

            if (this.search_text.length > 0) {
                this.getEstabsSearch();
            }

            window.addEventListener('scroll', this.handleScroll);

            this.barra_pat = this.shuffle(this.barra_pat);

            // this.panoInd = (this.panoInd + 1) % 5;
            this.panoInd = Math.floor(Math.random() * this.pano.length);
            //this.panoInd = 0;

            if (this.user.idioma > 0) {
                this.changeIdioma(this.user.idioma);
            }

            console.log('idCat: ', this.idCat);
            console.log('getCat: ', this.getCat(this.idCat));
            let cat = this.getCat(this.idCat);
            if (this.subCatIndex == 0) {
                this.subCatText = this.getInterCatName(cat);
                console.log('3::setando o subCatText para: ', this.subCatText);
            }

            console.log('Terminei o mounted!!');

            this.loginApplePrepare();

            // Inicializa o estado correto do botão "TOPO" ao carregar a página
            this.handleScroll();
        }

        beforeDestroy () {
            window.removeEventListener('scroll', this.handleScroll);
        }
        */
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
            this.handleScroll();  // Para inicializar o estado correto ao carregar a página
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }



</script>

<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/adv.css" scoped/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .roothome_m {
        /*background-color: #E4E4E4;*/
        background-color: var(--main-bg-color-new);
    }

    .wrapper {
        /*background-color: red;*/
    }

    .head1, .head2, .head3 {
        height: 100%;
        margin:auto;
        display: inline-block;
        position: relative;
    }
    .head1 {
        width: 13%;
        /*background-color: red;*/
        text-align: left;
        display: flex;
        justify-content: center;
    }
    .head2 {
        display: flex;
        /*background-color: gray;*/
        flex-direction: row;
        justify-content: flex-start;
        /*justify-content: flex-end;*/
        align-items: center;
        /*width: 56%;*/
        width: 65%;
        padding: 0;
        /*background-color: deeppink;*/
        text-align: left;
    }
    .head3 {
        /*width: 29%;*/
        width: 20%;
        /*background-color: aqua;*/
        text-align: right;
    }
    .im_pontos {
        /*background-color: red;*/
        margin-right: 2vw;
    }
    .hidden {
        opacity: 0;
        pointer-events: none;
    }
    .di_profile_m {
        padding-top: 7%;
        padding-bottom: 7%;
        margin-right: 5%;
    }
    .im_profile, .im_profile_2 {
        display: flex;
        height: 80%;
        margin-top: 0.74vh;
    }
    .im_profile_2 {
        margin-top: 10px;
        height: 40px;
        width: 40px;
        object-fit: cover;
        border-radius: 50%;
    }
    .im_degrade {
        position: absolute;
        width: 100%;
        height: 12px;
    }
    .im100_search {
        position: relative;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        object-fit: cover;
    }
    .di_estabelecimento0, .di_estabelecimento0_2 {
        background-color: var(--bg-header-color);
        /*background-color: red;*/
        margin-top: 10px;
        width: 96vw;
        margin-right: 2vw;
        margin-left: 2vw;
        alignment: center;
        text-align: center;
        /*border-radius: 6px;*/
        overflow: hidden;
    }
    .di_estabelecimento0_2 {
        background-color: transparent;
        margin-top: 2vw;
        margin-bottom: 1vw;

        /*-webkit-box-shadow: 2px 2px 2px var(--font-shadow-gray);*/
        /*-moz-box-shadow: 2px 2px 2px var(--font-shadow-gray);*/
        /*box-shadow: 2px 2px 2px var(--font-shadow-gray);*/

        -webkit-box-shadow: 1px 1px 1px var(--font-shadow-gray);
        -moz-box-shadow: 1px 1px 1px var(--font-shadow-gray);
        box-shadow: 1px 1px 1px var(--font-shadow-gray);
    }
    .di_estabelecimento1 {
        /*background-color: red;*/
        display: inline-block;
        /*margin-top: 10px;*/
        /*margin-top: 1.2vh;*/
        position: relative;
        width: 94%;
        width: 96vw;
        text-align: left;
        /*margin-bottom: 20px;*/
        margin-bottom: 1.4vh;
        cursor: pointer;
    }
    .di_estabelecimento1_2 {
        background-color: white;
        border-radius: 5px;
        overflow: hidden;
        display: flex;
        position: relative;
        width: 100%;
        text-align: left;
        height: 12vh;
        font-size: 1.4vh;
    }
    .di_estabelecimento2 {
        /*background-color: blue;*/
        text-align: center;
        width: 100%;
        display: inline-block;
    }
    .di_estabelecimento2_2 {
        /*background-color: blue;*/
        text-align: center;
        width: 33%;
        height: 100%;
        min-height: 100%;
        display: flex;
        /*display: inline-block;*/
    }
    .imgDestaques {
        object-fit: cover;
        width: 100%;
        /*height: 100%;*/
        max-height: 50vh;
        min-height: 30vh;
        background-color: var(--empty-color);
    }
    .im_categoria2, .im_categoria3 {
        background-size: contain;
        object-fit: contain;
        width: 60px;
        height: 60px;

    }
    .im_categoria2 {
        width: 40px;
        height: 40px;
    }
    .im_categoria3 {
        filter: url(#colorize);
        width: 30px;
        height: 30px;
        margin-right: 2vw;
        margin-left: 2vw;
        width: 3vh;
        height: 3vh;
    }
    .tx_categoria {
        /*background-color: yellow;*/
        display: inline-grid;
        /*white-space: pre-line;*/
        white-space: nowrap;
        width: auto;
        overflow: hidden;
        text-overflow: ellipsis;
        /*line-height: 0.9;*/
        color: var(--bg-blue);
        font-size: 3vw;
    }
    .scrollhorizontal {
        overflow-x: auto;
        white-space: nowrap;
        display: flex;
        /*background: red;*/
    }
    .scrollhorizontal::-webkit-scrollbar {
        /* This is the magic bit */
        display: none;
    }

    .search1 {
        border: none;
        outline:none;
        color: var(--menu-icon-gray);
        /*color: red;*/
        position: center;
        padding-left: 2%;
        width: 93%;
        height: 100%;
        /*font-size: 10pt;*/
        font-size: 2.5vh;
        text-align: left;
    }

    .search_lupa {
        width: 6%;
        height: 50%;
        object-fit: scale-down;
        /*background-color: red;*/
        /*margin-left: 2.5%;*/
        position: relative;
    }

    /*.di_banner {*/
        /*padding-top: 80px;*/
    /*}*/
    .banner {
        width: 94%;
        margin-right: 3%;
        margin-left: 3%;
    }

    .title {
        display: flex;
        align-items: center;
        justify-content: left;
        background-color: white;
        border-radius:5px;
        margin-right: 2vw;
        margin-left: 2vw;
        margin-bottom: 1vw;
        padding: 2px;
        padding-top: 0;
        font-size: 20pt;
        height: 5vh;
        height: 3vh;
        /*color: red;*/
        color: var(--bg-blue);
        /*font-weight: bold;*/
    }
    .title0 {
        /*background-color: blue;*/
        height: 12px;
        text-align: left;
    }
    /*.di_star_wrap {*/
        /*!*background-color: #2c3e50;*!*/
        /*display: inline-block;*/
        /*text-align: center;*/
        /*vertical-align: middle;*/
        /*position: relative;*/
    /*}*/
    /*.im_star {*/
        /*height: 100%;*/
        /*position: relative;*/
        /*height: 3.1vw;*/
    /*}*/

    .panoramica {
        /*margin-top: 60px;*/
        margin-top: var(--top-bar-heigth);
        text-align: center;
        /*height: 220px;*/
        /*height: 140px;*/
        /*height: auto;*/
        /*height: 15vh; tirei isso aqui*/
        overflow-y: hidden;
        /*background-color: red;*/
        margin-bottom: -10px;
    }
    #btn_topo {
        display: flex;
        justify-content: center;
        flex-direction: column;
        position: fixed;
        right: 4%;
        bottom: 2%;  /* Este valor será ajustado dinamicamente */
        background-color: white;
        width: 4.5vh;
        height: 5.5vh;
        border-color: var(--blue-text);
        border-style: solid;
        border-width: 1px;
        border-radius: 5px;
    }
    .im_loading {
        width: 50px;
        height: 50px;
        display: inline-block;
    }

    .div_pat_p {
        /*background-color: #949494;*/
        /*background-color: #E4E4E4;*/
        /*background-color: red;*/
        /*background-color: #B4B4B4;*/
    }

    .parceiros-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
    }

    .tx_parceiros {
        display: inline-block; /* Permite definir a largura */
        width: 80%; /* Ajuste a largura conforme necessário */
        text-align: center; /* Centraliza o texto */
        margin: 0 auto; /* Centraliza a span */
    }

    .parceiro-item {
        flex: 0 0 50%; /* Cada item ocupa 50% da largura do contêiner */
        display: flex;
        justify-content: center;
        margin-top: 50px; /* Espaçamento entre as linhas */
    }

    .im_pat {
        width: 70%; /* Aumenta a largura da imagem para 70% do item */
        height: auto; /* Mantém a proporção da imagem */
    }

    .im_pat_mangabeira {
        max-width: 90%;
        height: auto;
        object-fit: contain; /* Ajusta a imagem do Mangabeira Shopping */
    }


    .im_pat_jcarneiro {
        max-width: 100%;
        height: auto;
        object-fit: contain; /* Ajusta a imagem do J Carneiro */
    }



</style>



// WEBPACK FOOTER //
// src/components/mHome.vue